import {Redirect} from 'react-router-dom';
// @ts-expect-error
import type {Match} from 'react-router-dom';

import type {User} from 'nutshell-core/types';

import {AccountPage} from '../../ui/peep/account/account-page';
import {ContactPage} from '../../ui/peep/contact/contact-page';
import {PeepPage} from '../../ui/peep/peep-page';

import {NoCrmAccessRedirect} from '../shared/crm-no-access-redirect';

import {getPeepIdFromSlug} from './helpers';

type Props = {
    user: User | null | undefined;
    entityType: 'person' | 'company';
    match: Match;
};

export function PeepPageRoot(props: Props) {
    const {user, entityType, match} = props;

    // If we've come here from another page, need to change the id on the body for styling
    const pageBody = document.querySelector('body');
    if (pageBody && pageBody.id !== 'peep') {
        pageBody.id = 'peep';
        pageBody.className = entityType === 'company' ? 'page accounts' : 'page contacts';
    }

    const peepSlug = match.params.peepSlug;

    const peepId = getPeepIdFromSlug(entityType, peepSlug);

    if (!peepSlug) {
        return <Redirect to={`/${entityType}`} />;
    }

    if (!props.user) {
        return null;
    }

    if (!user || !user.permissions.canAccessCrm) {
        return <NoCrmAccessRedirect />;
    }

    if (NutClientConfig.hasPeepPagesRedesignFF && entityType === 'company') {
        return <AccountPage accountId={peepId} user={user} />;
    }
    if (NutClientConfig.hasPeepPagesRedesignFF && entityType === 'person') {
        return <ContactPage contactId={peepId} user={user} />;
    }

    return <PeepPage peepSlug={peepSlug} entityType={entityType} />;
}
